import { env } from '@repo/env';
import { type ABSmartlySDKOptions } from '../types';

export const abSmartlySdkConfig: ABSmartlySDKOptions = {
  endpoint: env.NEXT_PUBLIC_ABSMARTLY_URL,
  apiKey: env.NEXT_PUBLIC_ABSMARTLY_API_KEY,
  environment: env.NEXT_PUBLIC_DEPLOYABLE_ENV,
  application: 'banking-shopping-client',
};
